export default class BAjax {
  static post (args) {
    let host = "https://localhost:8000";
    var reg = /^(192.168.3.)/;
    if (window.location.hostname !== 'localhost' && !reg.test(window.location.hostname)) {
      host = "https://www.blbsoft.com"
    }
    let url_root = "/rav/";
    if(args['url_root']){
      url_root = args['url_root'];
    }
    let url = args['url'];

    let data = {};
    if(args['data']){
      data = args['data'];
    }

    let success = args['success'];
    $.ajax({
      type: "GET",
      url: host + url_root + url,
      data: data,
      success: (resp_data) => {
        // console.log(resp_data);
        if (resp_data['status'] == 0) {
          success(resp_data['data']);
        }
      }

    })
  }
}